import { render, staticRenderFns } from "./PayrollTypeEdit.vue?vue&type=template&id=579d5e28"
import script from "./PayrollTypeEdit.vue?vue&type=script&lang=js"
export * from "./PayrollTypeEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports